export interface ResultList<T> {
  count: number;
  result: T[];
}
